import routesPageTitles from './modules/core/json/routesPageTitles.json';

export function updatePageTitle(pathname) {
  const title = routesPageTitles[pathname] || 'Seguro garantia';
  document.title = `Junto Seguros - ${title}`;
}

export function rdStationTracking(pathname) {
  if (!window.LeadTracking) return;

  const { hostname } = window.location;
  window.LeadTracking.send({
    url: `${hostname}${pathname}`,
    token: process.env.REACT_APP_RD_TOKEN,
  });
}

export function initializeGATracking() {
  if (window.ga) {
    window.ga('create', process.env.REACT_APP_GA_TRACKING_ID, 'auto', 'junto_tracker');
    window.ga('send', 'pageview');

    console.log('Tracking created');
  } else {
    setTimeout(initializeGATracking, 500);
  }
}
